import { isNumber } from 'lodash';

const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];

function fileSizeFilter(bytes, precision: string | number = units[0], unitCase = 'upper') {
  let unit = 0;

  if (!isNumber(parseFloat(bytes))) {
    return '?';
  }
  bytes = +bytes;

  while (bytes >= 1024) {
    bytes /= 1024;
    unit += 1;
  }

  if (unitCase === 'upper') {
    return [bytes.toFixed(+precision), units[unit].toUpperCase()].join('');
  }

  return [bytes.toFixed(+precision), units[unit].toLowerCase()].join('');
}

export default fileSizeFilter;
